import React, { Component } from 'react';
import { Modal, Form } from 'antd';
import PropTypes from 'prop-types';

const FormItem = Form.Item;

class FormModal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        let { onRef, form } = this.props;
        if (onRef) {
            this.props.onRef(form);
        }
    }

    /**
     * 表单提交
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log(values)
                this.props.onSubmit(values);
            }
        });
    }

    render() {
        let { children, modal, form, formObj, other } = this.props,
            { getFieldDecorator } = form;
        modal.onOk = this.handleSubmit;
        return (
            <Modal {...modal}>
                <Form {...(formObj || {})}>
                    {children.map((node, i) => {
                        return (
                            <FormItem
                                {...node.formItemLayout}
                                label={node.label}
                                key={i}
                            >
                                {getFieldDecorator(node.name, node.options || {})(node.component)}
                            </FormItem>
                        );
                    })}
                </Form>
                {other || null}
            </Modal>
        );
    }
}

FormModal.propTypes = {
    modal: PropTypes.object.isRequired,
    formObj: PropTypes.object,
    onSubmit: PropTypes.func,
    onRef: PropTypes.func,
    other: PropTypes.any,
}

export default Form.create()(FormModal);



// WEBPACK FOOTER //
// ./src/components/FormModal2.jsx